export const APP_NAME = 'WealthTimeline';
